import { FC } from 'react';

import { SocialIconProps } from 'components/ui/icons/socialIcons/types';

export enum SocialNetworkType {
  vk = 'vk',
  max = 'max',
  telegram = 'telegram',
  ok = 'ok',
  rutube = 'rutube',
  dzen = 'dzen',
  yappi = 'yappi',
  tenchat = 'tenchat',
}

export type SocialNetwork = {
  url: string;
  Icon: FC<SocialIconProps>;
};
